import { render, staticRenderFns } from "./RiskyUsersPolicyScriptModal.vue?vue&type=template&id=56b6d52a&"
import script from "./RiskyUsersPolicyScriptModal.vue?vue&type=script&lang=ts&"
export * from "./RiskyUsersPolicyScriptModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports